import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useConfig } from '@chainlit/react-client';

import LanguageSwitcher from '@/components/header/LanguageSwitcher';
import NewChatButton from '@/components/header/NewChat';
import SidebarTrigger from '@/components/header/SidebarTrigger';
import { ThemeToggle } from '@/components/header/ThemeToggle';

// Desktop keeps the conversation canvas clear; compact controls remain
// available in the mobile header where the sidebar is otherwise hidden.
const ChatHeader = memo(() => {
  const navigate = useNavigate();
  const { config } = useConfig();

  return (
    <header className="fongpt-chat-header pointer-events-none absolute top-0 left-0 right-0 z-30 flex h-14 items-center justify-between px-3 md:px-4">
      <div className="flex items-center gap-1 pointer-events-auto md:hidden">
        {config?.dataPersistence ? <SidebarTrigger /> : null}
        <NewChatButton navigate={navigate} />
      </div>
      <div className="ml-auto flex items-center gap-1 pointer-events-auto">
        <LanguageSwitcher />
        <ThemeToggle />
      </div>
    </header>
  );
});

export default ChatHeader;
